var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFilter = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.5 0 .418.006A.5.5 0 0 0 .115.82l9.884 11.95L10 23.5a.5.5 0 0 0 .854.354l3-3 .05-.06A.5.5 0 0 0 14 20.5l-.001-7.73L23.885.819A.5.5 0 0 0 23.5 0H.5Zm21.937.999-9.322 11.272-.05.072a.5.5 0 0 0-.065.247l-.001 7.703-2 2L11 12.59l-.007-.086a.5.5 0 0 0-.108-.233L1.562 1h20.875Z",
    fillRule: "nonzero"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFilter);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/filter.8be38dc1ac7a3e8dd8b4a5c2d4f62ea6.svg";